import type { OutboxItemState } from '@Domain/Ports/Outbox/OutboxPort';

/**
 * French label for an outbox item's state, shared by every screen that renders a queue item.
 * `'confirmed'` is covered for exhaustiveness: a consumer that filters confirmed items out before
 * reaching this function (the beneficiary file's pending-transfers section) never actually renders
 * it, but a future consumer might.
 */
const outboxItemStateLabel = (state: OutboxItemState): string => {
	switch (state) {
		case 'draft':
			return "En cours d'enregistrement";
		case 'pending':
			return 'En attente de transfert';
		case 'transferring':
			return 'Transfert en cours';
		case 'verifying':
			return 'Vérification en cours';
		case 'failed':
			return 'Échec du transfert';
		case 'orphaned':
			return 'Supprimé du dossier — décision attendue';
		case 'confirmed':
			return 'Transfert confirmé';
		case 'expired':
			return 'Effacé après expiration';
	}
};

export default outboxItemStateLabel;
